import { useHttp } from '../http'

export const useClubProductHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`club-products/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`club-products`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`club-products/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`club-products`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`club-products/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`club-products/${id}/photo`, payload)
    }

    return {
        find,
        create,
        update,
        get,
        del,
        photo
    }
}
